const idPortalApi = "789277fed5f6ff14c372c319869ba278ede428c0";

module.exports = {
  idPortalApi: `${idPortalApi}`,
  tokenLink: `${idPortalApi}`, //Token para acessar o WWW.transparência
  // Produção
  urlApi: `https://api-portais-workcenter.com.br/${idPortalApi}`,
  // urlApi: `http://localhost:8004/${idPortalApi}`,
  urlADM: `https://administracaopublica.com.br`,

  dnsPortal: "tamborildopiaui.pi.gov.br",

  NomePortal: "Tamboril do Piauí",
  ufPortal: "PI",
  NomeTipoPortal: "Prefeitura Municipal", //Prefeitura ou Câmara
  TipoPortal: 3, //3 = Prefeitura 4 = Câmara

  //Variável em teste (newsViewRoute)
  newsViewRoute: true, //Essa opção informa se a rota de visualização de uma única noticia está disponível (Raposa gera as noticias pelo lado do servidor com nextjs)

  countNewsHome: 6, //quantidade de noticias na home

  RoutesDaily: true, //Deixa ativado as rotas para a pagina de diario

  link: "http://www.transparenciadministrativa.com.br", //Onde o token abaixo ser[a utilizado]
  linkArquivos: "http://www.transparenciadministrativa.com.br/portalimagem", //Onde o token abaixo ser[a utilizado]

  urlEmDeploy: "https://tamborildopiaui.pi.gov.br/", //usada para link de compartilhamento
  imagemURL: "https://cdn.administracaopublica.com.br/complementares/", //link para a imagem
  //imagemURL: 'http://localhost:8004/uploads/', //link para a imagem

  corIcones: "#000080",
  link_youtube: `#`,
  link_localize: `https://maps.app.goo.gl/Vq8nTYDGvheS5aHS7`,

  link_mapa: `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31576.095253899515!2d-42.917260541814926!3d-8.400488665924776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x779b43fcd2c0415%3A0xa25b664a971980d0!2sTamboril%20do%20Piau%C3%AD%2C%20State%20of%20Piau%C3%AD%2C%2064893-000!5e0!3m2!1sen!2sbr!4v1739040814936!5m2!1sen!2sbr`,
};